import { observable, configure, action, computed } from 'mobx';
import LocalModel from './localModel';

import util from 'preact-util';
import { route } from 'preact-router';
import PubSub, { topics } from '../lib/pubsub';

configure({ enforceActions: 'always' });

class CommentStore extends LocalModel {
    constructor() {
        super('comment', {
            namePlural: 'comments',
            namePluralReal: 'comments',
            sort: 'createdDate',
            limit: 500,
            api: {
                search: {
                    url: '/api/comments/',
                    params: {
                        limit: 50,
                        sort: 'lastname',
                    },
                },
                load: {
                    url: '/api/comments/',
                    params: {},
                },
                save: {
                    url: '/api/comments/',
                    params: {},
                },
                delete: {
                    url: '/api/comments/',
                    params: {},
                },
            },
        });
    }

    @observable showAddComment = {};

    @observable newComment = {};

    @observable comment = {};

    @observable comments = [];

    @observable aiResponse = {};
    @observable aiResponseObject = {};

    cleanupAi() {
        this.updateKeyValue('aiResponse', {});
        this.updateKeyValue('aiResponseObject', {});
    }

    async queryAi(message, field) {
        this.cleanupAi();
        const response = await util.fetchApi(`/api/ai/comment`, { method: 'POST' }, {
            message,
        });
        switch (response?.status) {
            case 200:
                this.updateKeyValue('aiResponse', response?.data);
                let responseObject = null;
                if (response?.data?.output_text) {
                    try {
                        responseObject = JSON.parse(response?.data?.output_text);
                    } catch (e) {
                        // Not JSON, do nothing
                    }
                }
                if (responseObject) {
                    this.updateKeyValue('aiResponseObject', responseObject);
                } else {
                    this.updateKeyValue('aiResponseObject', { [field]: response?.data?.output_text });
                }
                return response?.data;

        }
    }

}

const store = new CommentStore();
export default store;

// Named export for the class itself
export { CommentStore };
